import type { ReturnTo } from "@/types/dragon-tiles";

export function isConnectorTileReturn(
  returnTo?: ReturnTo,
): returnTo is "connector-tile" {
  return returnTo === "connector-tile";
}

export function resolveConnectorParentTileId(
  parentTileId: string,
  returnTo: ReturnTo | undefined,
  connectorParentTileId?: string,
): string {
  return isConnectorTileReturn(returnTo)
    ? (connectorParentTileId ?? parentTileId)
    : parentTileId;
}
